<template>
    <div class="tv container">

        <div class="tv_cont">

            <div class="column waitting_cont_tv">
                <div class="upanddown_cont">
                    <h1 class="showering_heading">SHOWERING</h1>
                    <div class="row pets_profile">
                        <!-- loop for div-->
                        <div class="" v-for="i in 6" :key="i">
                            <div class="row pet_conttt">
                                <div class="pet_profile_pic"></div>
                                <div class="pet_name_tv">Pet {{ i }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- video -->
            <div class="video_container">
                <video controls autoplay muted>
                    <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>

            <div class="column waitting_cont_tv waitting_cont_tv_up_next">
                <div>
                    <h1 class="showering_heading showering_heading_up_next">UP NEXT</h1>
                    <div class="row pets_profile">
                        <!-- loop for div-->
                        <div class="" v-for="i in 6" :key="i">
                            <div class="row pet_conttt">
                                <div class="pet_profile_pic"></div>
                                <div class="pet_name_tv">Pet {{ i }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
export default {
    name: 'TV',
    data() {
        return {
            // You can add any data properties you need here
        };
    },
    methods: {
        // You can add any methods you need here
    }
};
</script>

<style scoped>
.tv {
    background-color: #f0f0f0;
    border-radius: 8px;
    font-family: 'nunito', sans-serif;
}

.tv p {
    color: #666;
    font-size: 16px;
}

.tv_cont{
    /* width: 80vw; */
    background-color: blanchedalmond;
}

.container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 2vh 0px;
}

.waitting_cont_tv{
    background-color: #f8fcff;
    border: 5px solid #01bcfe;
    border-radius: 5px 5px 0px 0px;
    /* padding: 10px 15px; */
    padding: 1vh 1vw;
    align-items: center;
}

.waitting_cont_tv_up_next{
    border-radius: 0px 0px 5px 5px;
    background-color: #fcfac9;
    border: 5px solid #f4e914;
}

.waitting_cont_tv{
    max-height: 20vh;
}

.showering_heading_up_next{
    color: #dbd001 !important;
}

.showering_heading{
    color: #28aae3;
    font-weight: bold;
    margin-top: 0px;
    font-size: 24px;
}

.pet_profile_pic{
    width: 7vh;
    height: 7vh;
    background-color: #ccc;
    border-radius: 50%;
    margin-right: 10px;
}

.pet_conttt{
    align-items: center;
    margin-right: 10px;
}

/* .video_container video{ */
    /* max-height: 80vw; */
    /* margin: 0px 10px; */
/* } */

.video_container{
    max-height: 50vh;
    height: 100%;
    height: 50vh;
}

.video_container video{
    width: 100%;
    height: 100%;
}

/* .pet_conttt:last-child{
    margin-right: 0;
} */

</style>